import CrudManager from "@/components/admin/CrudManager";
import { useSeo } from "@/hooks/useSeo";

const AdminPendaftaran = () => {
  useSeo("Kelola Link Pendaftaran");
  return (
    <CrudManager
      title="Link Pendaftaran (PPDB)"
      description="Kelola link Google Form pendaftaran siswa baru per tahun pelajaran."
      endpoint="/registration-links"
      prefix="admin-reg"
      defaults={{ is_active: true }}
      columns={[
        { name: "year", render: (i) => `Tahun Pelajaran ${i.year}` },
        { name: "meta", render: (i) => (i.url ? i.url : "Belum ada link") },
        { name: "status", render: (i) => (i.is_active ? "✅ Aktif" : "Nonaktif") },
      ]}
      fields={[
        { name: "year", label: "Tahun Pelajaran", type: "text", required: true, placeholder: "cth: 2026/2027" },
        { name: "url", label: "Link Google Form", type: "text", full: true, placeholder: "https://forms.gle/..." },
        { name: "note", label: "Catatan", type: "textarea", rows: 2, placeholder: "cth: Pendaftaran dibuka Mei 2026" },
        { name: "is_active", label: "Status Aktif", type: "select", options: ["true", "false"] },
      ]}
    />
  );
};

export default AdminPendaftaran;
